import { grey, Tooltip } from "@flat-ui";
import { Grid } from "@mui-wrapper";

interface Props {
  /** Element that will be rendered on the left side in an InfoRow */
  label: string;

  /** Element that will be rendered on the right side in an InfoRow */
  info?: React.ReactNode;

  /** The tooltip content to be displayed alongside the info */
  tooltip?: React.ReactNode;

  /** The alignment of the text */
  labelTextAlign?: "left" | "right";
}

/** Displays a pair for label/info in a flex row */
function InfoRowBase({
  label,
  info,
  labelTextAlign = "right",
}: Exclude<Props, "tooltip">): React.JSX.Element {
  return (
    <Grid container sx={{ p: "3px 0px" }}>
      <Grid
        sx={{
          minWidth: "40%",
          textAlign: labelTextAlign,
          pr: "10px",
          color: grey[400],
          alignSelf: "center",
        }}
      >
        {`${label}:`}
      </Grid>
      <Grid
        sx={{
          color: grey[800],
          overflowWrap: "anywhere",
          whiteSpace: "pre",
          maxHeight: "200px",
          overflowY: "auto",
          flexGrow: 1,
        }}
      >
        {info}
      </Grid>
    </Grid>
  );
}

/** Displays a pair for label/info in a flex row with an optional tooltip */
export function InfoRow({ tooltip, ...props }: Props): React.JSX.Element {
  if (tooltip) {
    return (
      <Tooltip title={tooltip}>
        <InfoRowBase {...props} />
      </Tooltip>
    );
  }
  return <InfoRowBase {...props} />;
}
